<template>
  <b-modal v-model="modal" :title="title" size="md" :no-enforce-focus="true" :no-close-on-backdrop="true">
    <div class="row">
      <div class="col-lg-12">
        <form @submit.prevent="applyFilter()" autocomplete="off">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="tags">TAG</label>
                <select
                  class="custom-select"
                  name="tag"
                  v-model="filter.tag"
                >
                  <option value="">TODOS</option>
                  <option v-for="(s,i) in tags" :key="i" :value="s.id">{{ s.name }}</option>
                </select>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button class="btn btn-dark" @click="clean()">Limpar</b-button>
      <button type="submit" class="btn btn-primary mr-1" @click="applyFilter()">Aplicar</button>
    </template>
  </b-modal>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'index-modal',
  components: {},
  props: {},
  data () {
    return {
      title: 'INFORMAR TAG DE ACESSO',
      filter: {},
      modal: false
    }
  },
  mounted () {
    this.getTags()
  },
  methods: {
    ...mapActions('tag', {
      getAll: 'getAll'
    }),
    getTags (filter) {
      let params = {
        search: this.search || null,
        limit: 100,
        page: 1
      }
      this.params = params
      this.getAll(this.params).then((res) => {
      }).catch(error => {
        console.log(error)
      })
    },
    open () {
      this.modal = true
    },
    applyFilter () {
      this.$emit('setFilter', this.filter)
      this.close()
    },
    close () {
      this.modal = false
    },
    clean () {
      this.filter = {}
    }
  },
  computed: {
    ...mapState('tag', ['tags', 'pagination'])
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>
.form-check-label { padding-top: 2px !important }
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
</style>
